import React, { useRef } from 'react';
import { string, func, bool } from 'prop-types';
import classnames from 'classnames';
import { gigShape } from '../../utils/propTypes';
import { sendMixpanelWidgetClickEvent } from '../../utils/mixpanel';
import { useGigImpression } from '../../hooks/useAfp1Impression';
import { useBQ } from '../../hooks/useBQ';
import { resolveGigImage } from '../../utils/gigImage';
import { Rating } from '../Rating';
import { TrackingLink } from '../TrackingLink';
import styles from './style.module.scss';

// @TODO: split to smaller components.
export const GigCard = (props) => {
    const { className, useLargeImage, gig, affiliateId, brand, afp, afp1, utmCampaign, widgetType } = props;

    const ref = useRef();
    const { sendBQEvent } = useBQ();

    const { id, url, title, rating, ratingsCount, thumbnail, price, seller } = gig;

    const hostReference = afp1;

    const gigName = url.split('/').pop();
    const gigNameShortened = gigName.length > 50 ? gigName.slice(gigName.length - 50) : gigName;
    const gigNameWithoutAction = gigNameShortened.slice(gigNameShortened.indexOf('-') + 1, gigNameShortened.length);

    const sizeAdjustedThumbnail = resolveGigImage(thumbnail, useLargeImage);

    const marketingParams = (afp3) => ({
        affiliateId,
        utmCampaign,
        widgetType,
        brand,
        slug: url,
        afp,
        afp1: hostReference,
        afp2: gigNameWithoutAction,
        afp3,
    });

    const onGigClick = () =>
        sendBQEvent({
            type: 'nga.clicked_gig',
            gigId: id,
            affiliateId,
            widgetType,
            afp1,
        });

    const onSectionClick = (clickSection) => () =>
        sendMixpanelWidgetClickEvent({
            affiliateId,
            clickName: gigNameWithoutAction,
            clickSection,
            hostReference,
        });

    useGigImpression({ affiliateId, afp1, gigId: gig.id, widgetType }, ref);

    return (
        <div
            className={classnames(styles.gig, { [styles['large-image']]: useLargeImage }, className)}
            ref={ref}
            onClick={onGigClick}
        >
            <TrackingLink
                className={styles.head}
                onClick={onSectionClick('gig_image')}
                {...marketingParams('gig_image')}
            >
                <img className={styles.image} src={sizeAdjustedThumbnail} alt="gig picture" />
            </TrackingLink>
            <TrackingLink
                className={styles.seller}
                onClick={onSectionClick('gig_seller')}
                {...marketingParams('gig_seller')}
            >
                <img className={styles['seller-avatar']} src={seller.profilePhoto} alt="seller avatar" />
                {seller.username}
            </TrackingLink>
            <TrackingLink
                className={styles.description}
                onClick={onSectionClick('gig_description')}
                {...marketingParams('gig_description')}
            >
                I will {title}
            </TrackingLink>
            <TrackingLink
                className={styles['rating-link']}
                onClick={onSectionClick('gig_rating')}
                {...marketingParams('gig_rating')}
            >
                <Rating count={ratingsCount} rating={rating} />
            </TrackingLink>
            <TrackingLink
                className={styles.price}
                onClick={onSectionClick('gig_price')}
                {...marketingParams('gig_price')}
            >
                STARTING AT <span className={styles['price-amount']}>${price}</span>
            </TrackingLink>
        </div>
    );
};

GigCard.propTypes = {
    className: string,
    useLargeImage: bool,
    gig: gigShape,
    affiliateId: string,
    brand: string,
    afp: string,
    afp1: string,
    utmCampaign: string,
    onMount: func,
    widgetType: string,
};
